import React from 'react';
import { useAuth } from '../contexts/AuthContext';

const AuthStatus: React.FC = () => {
  const { 
    isAuthenticated, 
    user, 
    userEmail,
    loading, 
    error, 
    signInWithRedirect, 
    signOutUser, 
    clearError 
  } = useAuth();

  if (loading) {
    return (
      <div className="auth-status loading">
        <div className="auth-spinner">🔄</div>
        <span>認証状態を確認中...</span>
      </div>
    );
  }

  if (error) {
    return (
      <div className="auth-status error">
        <div className="auth-error">
          <span>⚠️ 認証エラー: {error}</span>
          <button onClick={clearError} className="error-clear-btn">
            ✕
          </button>
        </div>
      </div>
    );
  }

  if (isAuthenticated && user) {
    return (
      <div className="auth-status authenticated">
        <div className="user-info">
          <div className="user-avatar">👤</div>
          <div className="user-details">
            <div className="user-email">{userEmail || 'ユーザー'}</div>
            <div className="user-status">ログイン中</div>
          </div>
        </div>
        <button onClick={signOutUser} className="auth-btn signout-btn">
          ログアウト
        </button>
      </div>
    );
  }

  return (
    <div className="auth-status unauthenticated">
      <div className="auth-message">
        <span>未ログイン</span>
      </div>
      <button onClick={signInWithRedirect} className="auth-btn signin-btn">
        ログイン
      </button>
    </div>
  );
};

export default AuthStatus;
